<!---------------------13. Assistant Registrar - Amendments Start---------------------------->

<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title m-0">New Amendments</h5>
        </div>
        <div class="card-body">
          <form [formGroup]="byLawsForm">
            <div class="row align-items-end mb-3">
              <div class="col-lg-3 col-md-6">
                <label class="form-label">Society Type</label>
                <select class="form-control" formControlName="societyType">
                  <option selected disabled value="0">
                    Select Society Type
                  </option>
                  <option
                    *ngFor="let item of societyDropdownData"
                    [value]="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="col-lg-9 col-md-6">
                <button
                  type="button"
                  class="btn bin-sm btn-primary"
                  (click)="submit()"
                >
                  Search
                </button>
              </div>
            </div>
          </form>

          <div class="table-responsive">
            <div class="col-lg-3 col-md-6 mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="Enter Keyword"
                placeholder="search"
                (keyup)="updateFilter($event)"
              />
            </div>
            <ngx-datatable
              class="ngx-datatable billdata colored-header sm table-striped table-hover"
              [rows]="AmendmentsList"
              [columns]="columns1"
              [columnMode]="'force'"
              [headerHeight]="50"
              [footerHeight]="50"
              rowHeight="auto"
              [columnMode]="'force'"
              [virtualization]="false"
              [scrollbarV]="true"
              [scrollbarH]="true"
            >
              <!-- Column Definitions -->
              <!-- Column Definitions -->

              <!-- Static Columns -->
              <ngx-datatable-column
                *ngFor="let column1 of columns1; let i = index"
                [name]="column1.name"
                [prop]="column1.prop"
                [width]="column1.width"
                [sortable]="column1.sortable"
              >
                <ng-template
                  ngx-datatable-cell-template
                  let-row="row"
                  let-rowIndex="rowIndex"
                  let-column="column1"
                >
                  <ng-container [ngSwitch]="column1.prop">
                    <!-- Serial Number Column -->
                    <ng-container *ngSwitchCase="'id'">{{
                      rowIndex + 1
                    }}</ng-container>
                    <ng-container *ngSwitchCase="'dCreateDate'">
                      <div class="d-flex">
                        <span>
                          {{ row?.dCreateDate | date: "dd/MM/yyyy" }}
                        </span>

                        <span
                          *ngIf="row?.sendBackCount > 0"
                          class="badge bg-warning text-dark ms-2"
                          [attr.title]="'Sent Back : ' + row.sendBackCount"
                          data-bs-toggle="tooltip"
                        >
                          {{ row?.sendBackCount }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'sAuditStatus'">
                      <!-- <span [ngClass]="
                                     row.sAuditStatus === 'Approved' ?'badge bg-success':
                                     row.sAuditStatus === 'Pending'?  'badge bg-warning':
                                     row.sAuditStatus === 'Rejected'?  'badge bg-danger':''
">
                                                {{ row?.sAuditStatus }}
                                            </span> -->
                      <span
                        [ngClass]="
                          row.sAuditStatus === 'Approved'
                            ? 'badge bg-success'
                            : row.sAuditStatus === 'Certificate Issued'
                              ? 'badge bg-success'
                              : row.sAuditStatus === 'Pending'
                                ? 'badge bg-warning text-dark'
                                : row.sAuditStatus === 'Rejected'
                                  ? 'badge bg-danger'
                                  : row.sAuditStatus === 'Fees Verification'
                                    ? 'badge bg-info text-dark'
                                    : row.sAuditStatus === 'Fees Verified'
                                      ? 'badge bg-info text-dark'
                                      : 'badge bg-secondary'
                        "
                      >
                        {{ row?.sAuditStatus }}
                      </span>
                    </ng-container>

                    <ng-container *ngSwitchCase="'action'">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-primary btn-sm"
                        (click)="getApplicationDetail(row)"
                      >
                        <i class="fa fa-eye"></i></a>
                      &nbsp;

                      <a *ngIf="row?.sNOCUpload"
                        href="javascript:void(0)"
                        class="btn btn-primary btn-sm"
                        (click)="downloadFile(row.sNOCUpload)"
                      >
                        <span>View NOC</span></a>
                      &nbsp;

                      <button
                        type="button"
                        class="btn btn-success btn-sm"
                        title="Download Certificate"
                        *ngIf="row?.sAssistantRegistrarDocument"
                        (click)="downloadDocument(row.sAssistantRegistrarDocument)"
                      >
                        <i class="bi bi-download" aria-hidden="true"></i>
                      </button>
                      &nbsp;
                      <!-- <a href="javascript:void(0)"
                                                class="btn btn-sm text-white px-3 py-1 fw-semibold border-0 rounded-3"
                                                style="background: linear-gradient(180deg,#0b2d4f,#184c86);"
                                                title="View Fee Details"
                                                *ngIf="row?.sAuditStatus == 'Fees Verification' || row?.sAuditStatus == 'Fees Verification Done'"
                                                (click)="GetPaymentVerifyDetails(row)">

                                                <i class="fa fa-money-check-alt me-1"></i>
                                                Payment Details

                                            </a> -->

                      <a
                        href="javascript:void(0)"
                        class="btn btn-success btn-sm"
                        title="View Payment Details"
                        *ngIf="
                          row?.sAuditStatus == 'Fees Verification' ||
                          row?.sAuditStatus == 'Fees Verified'
                        "
                        (click)="GetPaymentVerifyDetails(row)"
                      >
                        <i class="fa fa-money"></i>
                      </a>
                      &nbsp;
                      <a
                        href="javascript:void(0)"
                        class="btn btn-primary btn-sm"
                        title="Upload Certificate"
                        (click)="uploadCerificate(row)"
                        *ngIf="
                          row?.sAuditStatus == 'Fees Verified' &&
                          row?.sAmendmentCertificate == null
                        "
                      >
                        <i class="fa fa-upload"></i>
                      </a>

                      <button
                        type="button"
                        class="btn btn-success btn-sm"
                        *ngIf="
                          row?.sAuditStatus == 'Certificate Issued' &&
                          row?.sAmendmentCertificate != null
                        "
                        (click)="downloadFile(row?.sAmendmentCertificate)"
                      >
                        <i class="bi bi-download me-1"></i>
                      </button>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      {{ row[column1.prop] }}
                    </ng-container>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!---------------------13. Assistant Registrar - Amendments End---------------------------->

<!---------------------13.1 Assistant Registrar - Amendments - Review Application - Application Details Start---------------------------->
<!---------------------13.2 Assistant Registrar - Amendments - Review Application - Process Order Start---------------------------->
<!---------------------13.3 Assistant Registrar - Amendments - Review Application - Status Details Start---------------------------->

<!-- =======================
     AMENDMENTS DETAILS MODAL
======================== -->

<div
  class="modal fade"
  id="AmendmentsAppDetails"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="AmendmentsAppDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-white border-bottom px-4 py-3">
        <div
          class="w-100 d-flex justify-content-between align-items-center flex-wrap gap-3"
        >
          <div>
            <h3 class="fw-bold text-primary mb-1">
              <i class="bi bi-file-earmark-text me-2"></i>
              Amendments Application
            </h3>
          </div>

          <div class="d-flex align-items-center gap-2 flex-wrap">
            <button
              class="btn rounded-pill px-4"
              [ngClass]="
                applicationModel == 1 ? 'btn-primary' : 'btn-outline-primary'
              "
              (click)="toggle(1)"
            >
              <i class="bi bi-card-list me-1"></i>
              Application Details
            </button>

            <!-- Amendment Accepted tab disabled: no partial order selection -->
            <!--
            <button
              class="btn rounded-pill px-4"
              *ngIf="currentUser.roleId == 13"
              [ngClass]="
                applicationModel == 2 ? 'btn-success' : 'btn-outline-success'
              "
              (click)="toggle(2)"
            >
              <i class="bi bi-patch-check me-1"></i>
              Amendment Accepted
            </button>
            -->

            <button
              class="btn rounded-pill px-4"
              [ngClass]="
                applicationModel == 3
                  ? 'btn-warning text-dark'
                  : 'btn-outline-warning'
              "
              (click)="toggle(3)"
            >
              <i class="bi bi-clock-history me-1"></i>
              Status Details
            </button>

            <button
              type="button"
              class="btn-close ms-2"
              data-bs-dismiss="modal"
              (click)="closeModal()"
            ></button>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12" *ngIf="applicationModel == 1">
            <div>
              <div>
                <div
                  class="d-flex align-items-center gap-2 mb-3 justify-content-between"
                >
                  <h6 class="election-title">Amendments Application Details</h6>
                  <div>
                    <div>
                      <select class="form-control" style="width: 150px">
                        <option selected disabled>
                          {{
                            aplicationDetailList?.selectedRow?.dCreateDate
                              | date
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="card border-0 rounded-4 shadow-sm mb-4">
                    <div class="card-body p-4">
                      <div
                        class="d-flex justify-content-between align-items-center mb-4"
                      >
                        <h5 class="fw-bold mb-0 text-dark">
                          <i class="bi bi-folder2-open me-2 text-primary"></i>
                          Uploaded Documents
                        </h5>
                      </div>

                      <div class="row g-3">
                        <div class="col-md-6 col-lg-3">
                          <div class="border rounded-4 p-3 bg-white h-100">
                            <div
                              class="d-flex flex-column align-items-center text-center"
                            >
                              <i
                                class="bi bi-file-earmark-pdf fs-1 text-danger mb-2"
                              ></i>

                              <h6 class="fw-semibold mb-3">
                                Proceeding Meeting
                              </h6>

                              <button
                                type="button"
                                class="btn btn-primary btn-sm rounded-pill px-4"
                                (click)="
                                  downloadFile(
                                    aplicationDetailList?.fileProceedingGHMPath
                                  )
                                "
                              >
                                <i class="bi bi-download me-1"></i>
                                Download
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-3">
                          <div class="border rounded-4 p-3 bg-white h-100">
                            <div
                              class="d-flex flex-column align-items-center text-center"
                            >
                              <i
                                class="bi bi-file-earmark-text fs-1 text-info mb-2"
                              ></i>

                              <h6 class="fw-semibold mb-3">Meeting Notice</h6>

                              <button
                                type="button"
                                class="btn btn-primary btn-sm rounded-pill px-4"
                                (click)="
                                  downloadFile(
                                    aplicationDetailList?.fileNoticeGHMPath
                                  )
                                "
                              >
                                <i class="bi bi-download me-1"></i>
                                Download
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-3">
                          <div class="border rounded-4 p-3 bg-white h-100">
                            <div
                              class="d-flex flex-column align-items-center text-center"
                            >
                              <i
                                class="bi bi-people fs-1 text-success mb-2"
                              ></i>

                              <h6 class="fw-semibold mb-3">Attendance Sheet</h6>

                              <button
                                type="button"
                                class="btn btn-primary btn-sm rounded-pill px-4"
                                (click)="
                                  downloadFile(
                                    aplicationDetailList?.fileMemberPresentPath
                                  )
                                "
                              >
                                <i class="bi bi-download me-1"></i>
                                Download
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-3">
                          <div class="border rounded-4 p-3 bg-white h-100">
                            <div
                              class="d-flex flex-column align-items-center text-center"
                            >
                              <i
                                class="bi bi-journal-text fs-1 text-warning mb-2"
                              ></i>

                              <h6 class="fw-semibold mb-3">Annotated Form</h6>

                              <button
                                type="button"
                                class="btn btn-primary btn-sm rounded-pill px-4"
                                (click)="
                                  downloadFile(
                                    aplicationDetailList?.fileProposedAmmendmentPath
                                  )
                                "
                              >
                                <i class="bi bi-download me-1"></i>
                                Download
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="card-header bg-white border-0 px-4 py-4">
                      <div
                        class="d-flex justify-content-between align-items-start flex-wrap gap-3 w-100"
                      >
                        <!-- Left Content -->
                        <div class="d-flex align-items-center gap-3">
                          <div
                            class="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center"
                            style="width: 55px; height: 55px; min-width: 55px"
                          >
                            <i class="bi bi-journal-text text-primary fs-4"></i>
                          </div>

                          <div>
                            <h4 class="fw-bold mb-1 text-dark">
                              Amendments Details
                            </h4>

                            <p class="text-muted mb-0 small">
                              Complete list of proposed amendments in by-laws
                            </p>
                          </div>
                        </div>

                        <!-- Right Corner Badge -->
                        <div class="ms-auto">
                          <div
                            class="badge bg-primary rounded-pill px-4 py-3 fs-6 shadow-sm"
                          >
                            <i class="bi bi-collection me-1"></i>
                            Total Amendments :
                            {{
                              aplicationDetailList?.byLawsDetails?.length || 0
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5 class="election-title">Amendments</h5>
                    <div
                      *ngIf="!aplicationDetailList?.byLawsDetails?.length"
                      class="text-center py-4 text-muted"
                    >
                      No Amendments Available
                    </div>
                    <div
                      class="table-responsive"
                      *ngIf="
                        aplicationDetailList?.byLawsDetails &&
                        aplicationDetailList?.byLawsDetails.length > 0
                      "
                    >
                      <ngx-datatable
                        #amendmentsDetailTable
                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                        [rows]="aplicationDetailList?.byLawsDetails"
                        [columns]="columns"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="'auto'"
                        [limit]="10"
                        [count]="aplicationDetailList?.byLawsDetails.length"
                        [columnMode]="'force'"
                        [virtualization]="false"
                        [scrollbarV]="false"
                        [scrollbarH]="true"
                        [externalPaging]="false"
                        style="min-height: 280px; width: 100%"
                      >
                        <ngx-datatable-column name="#" prop="index">
                          <ng-template
                            let-row="row"
                            ngx-datatable-cell-template
                            let-rowIndex="rowIndex"
                          >
                            {{ rowIndex + 1 }}
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                          name="Amendment Type"
                          prop="amendmentType"
                        >
                          <ng-template
                            let-row="row"
                            ngx-datatable-cell-template
                          >
                            {{ typeName(row?.sAmmendmentTypeSubject || null) }}
                          </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                          name="Amendment Action Type"
                          prop="amendmentType"
                        >
                          <ng-template
                            let-row="row"
                            ngx-datatable-cell-template
                          >
                            {{ getAmendmentActionLabel(row) }}
                          </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                          name="Bylaws Number"
                          prop="sByLawsNo"
                        >
                          <ng-template
                            let-row="row"
                            ngx-datatable-cell-template
                          >
                            {{ row.sByLawsNo }}
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                          name="New By-laws"
                          prop="sNewByLawsDetail"
                        >
                          <ng-template
                            let-row="row"
                            ngx-datatable-cell-template
                          >
                            <!-- {{ row.sNewByLawsDetail }} -->
                            <app-read-more
                              text="{{
                                row.sNewByLawsDetail
                                  ? row.sNewByLawsDetail
                                  : 'NA'
                              }}"
                              [maxLength]="15"
                              (viewMore)="viewMore($event)"
                            ></app-read-more>
                          </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                          name="Existing By-Laws"
                          prop="sExistByLawsDetail"
                        >
                          <ng-template
                            let-row="row"
                            ngx-datatable-cell-template
                          >
                            <!-- {{ row.sNewByLawsDetail }} -->
                            <app-read-more
                              text="{{
                                row.sExistByLawsDetail
                                  ? row.sExistByLawsDetail
                                  : 'NA'
                              }}"
                              [maxLength]="15"
                              (viewMore)="viewMore($event)"
                            ></app-read-more>
                          </ng-template>
                        </ngx-datatable-column>
                        <!-- <ngx-datatable-column name="Liability" prop="isLiability">
                                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                                        {{ (row.isLiablity == 1) ? 'Yes' : 'No' }}
                                                    </ng-template>
                                                </ngx-datatable-column> -->

                        <ngx-datatable-column name="Action">
                          <ng-template
                            let-row="row"
                            ngx-datatable-cell-template
                          >
                            <a
                              href="javascript:void(0)"
                              *ngIf="row.isLiablity === 1"
                              class="btn btn-primary btn-sm"
                              (click)="downloadFile(row.sRegistrarApprovalPath)"
                            >
                              <i
                                class="bi bi-download"
                                aria-hidden="true"
                              ></i> </a
                            >&nbsp;
                            <button
                              type="button"
                              class="btn btn-info btn-sm me-1"
                              title="View Disclaimer"
                              (click)="showDiclamer(row)"
                            >
                              <i class="bi bi-eye"></i>
                            </button>

                            <!-- <a class="btn btn-primary" [href]="'https://localhost:44346/api/ByLaws/DownloadImage?url=UploadedFiles/ByLaws/1743231993_4529_Persistance.png'" 
                                                         >Download</a> -->
                          </ng-template>
                        </ngx-datatable-column>
                      </ngx-datatable>
                    </div>
                  </div>

                  <!-- <div class="col-lg-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value=""
                                                id="CheckAmendmentsFive" checked disabled>
                                            <label class="form-check-label" for="CheckAmendmentsFive">
                                                The Amendments in the By-laws have been made in the general meeting of
                                                the society in which quorum was present or in an adjourned general
                                                meeting of the society.
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value=""
                                                id="CheckAmendmentsSix" checked disabled>
                                            <label class="form-check-label" for="CheckAmendmentsSix">
                                                Due notice to all the member along with agenda (i.e. amendment of
                                                By-Laws) was given.
                                            </label>
                                        </div>
                                    </div> -->
                  <!-- <div id="disclaimerList">
                                        <ng-container *ngIf="showDisclamer">
                                            <div class="col-md-12"
                                                *ngFor="let option of disclamerOptions; let i = index">
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input"
                                                        [checked]="option.iDisclaimerId" [disabled]="true">
                                                    <label class="form-check-label">{{ option.sDisclaimer }}</label>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Amendment Accepted / order checkbox panel disabled -->
          <div class="col-lg-12" *ngIf="false && applicationModel == 2">
            <div>
              <div>
                <h6 class="election-title">Select Amendments for Orders</h6>

                <div class="table-responsive">
                  <ngx-datatable
                    class="ngx-datatable billdata colored-header sm table-striped table-hover"
                    [rows]="orderData"
                    [columns]="orderColumns"
                    [columnMode]="'force'"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    rowHeight="auto"
                    [columnMode]="'force'"
                    [selected]="selected"
                    [selectionType]="SelectionType.checkbox"
                    (select)="onSelect($event)"
                    [virtualization]="false"
                    [scrollbarV]="true"
                    [scrollbarH]="false"
                  >
                    <!-- Column Definitions -->
                    <!-- Column Definitions -->
                    <ngx-datatable-column
                      name="#"
                      prop="index"
                      [sortable]="false"
                      [maxWidth]="60"
                    >
                      <ng-template
                        let-row="row"
                        ngx-datatable-cell-template
                        let-rowIndex="rowIndex"
                      >
                        {{ rowIndex + 1 }}
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column
                      name="ByLaws Number"
                      prop="sByLawsNo"
                      [sortable]="true"
                      [maxWidth]="200"
                    >
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        {{ row.sByLawsNo }}
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                      name="New By-laws"
                      prop="sNewByLawsDetail"
                    >
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <!-- {{ row.sNewByLawsDetail }} -->
                        <app-read-more
                          text="{{
                            row.sNewByLawsDetail ? row.sNewByLawsDetail : 'NA'
                          }}"
                          [maxLength]="15"
                          (viewMore)="viewMore($event)"
                        ></app-read-more>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                      name="Existing By-Laws"
                      prop="sExistByLawsDetail"
                    >
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <!-- {{ row.sNewByLawsDetail }} -->
                        <app-read-more
                          text="{{
                            row.sExistByLawsDetail
                              ? row.sExistByLawsDetail
                              : 'NA'
                          }}"
                          [maxLength]="15"
                          (viewMore)="viewMore($event)"
                        ></app-read-more>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                      [width]="30"
                      [sortable]="false"
                      [canAutoResize]="false"
                      [draggable]="false"
                      [resizeable]="false"
                      [headerCheckboxable]="true"
                    >
                      <!-- <ng-template
                                        ngx-datatable-header-template
                                        let-allRowsSelected="allRowsSelected"
                                        let-selectFn="selectFn"
                                      >
                                        <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn()" />
                                      </ng-template> -->
                      <ng-template
                        ngx-datatable-header-template
                        let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn"
                      >
                        <input
                          type="checkbox"
                          [checked]="allRowsSelected"
                          [disabled]="
                            this.aplicationDetailList.selectedRow
                              ?.sAuditStatus == 'Approved' ||
                            this.aplicationDetailList.selectedRow
                              ?.sAuditStatus == 'Rejected'
                          "
                          (change)="selectFn()"
                        />
                      </ng-template>
                      <ng-template
                        ngx-datatable-cell-template
                        let-value="value"
                        let-row="row"
                        let-isSelected="isSelected"
                        let-onCheckboxChangeFn="onCheckboxChangeFn"
                      >
                        <input
                          type="checkbox"
                          [checked]="isSelected"
                          [disabled]="
                            this.aplicationDetailList.selectedRow
                              ?.sAuditStatus == 'Approved' ||
                            this.aplicationDetailList.selectedRow
                              ?.sAuditStatus == 'Rejected'
                          "
                          (change)="onCheckboxChangeFn($event)"
                        />
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
                  <!-- <table class="table table-hover align-middle text-nowrap table-bordered">
                        <thead>
                            <tr>
                                <th class="text-dark font-medium">#</th>
                                <th class="text-dark font-medium">Bylaws Number</th>
                                <th class="text-dark font-medium">Bylaws</th>
                                <th class="text-dark font-medium text-center">
                                    <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersAll">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                            <tr>
                                <td>2</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                            <tr>
                                <td>3</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                        </tbody>
                    </table> -->
                </div>

                <!-- <div class="text-end">
                                    <button type="button" class="btn btn-primary" (click)="orders()"> Order</button>
                                </div> -->
              </div>
            </div>
          </div>

          <div class="col-lg-12" *ngIf="applicationModel == 3">
            <div class="row">
              <div class="col-lg-12">
                <h6 class="election-title">Amendments Application Status</h6>
              </div>
              <div class="col-lg-5">
                <div class="card">
                  <div class="card-body">
                    <div class="step-progressbar">
                      <div class="v-progress progress-area">
                        <ul>
                          <li
                            *ngFor="let item of bylawsProgress"
                            [class]="item?.ProgressClass"
                          >
                            {{ item?.AuditStatus }} -
                            <small style="font-size: 12px">{{
                              item?.dCreatedDate | date: "dd/MM/yyyy"
                            }}</small>
                            <br />
                            <b style="font-size: 12px"
                              >( {{ item?.RoleName }} )</b
                            >
                            <!-- AR / DI / BI: View Remark on Send Back / Move Forward entries -->
                            <a
                              *ngIf="canShowOfficerViewRemark(item)"
                              href="javascript:void(0)"
                              class="ms-2 text-primary fw-semibold text-decoration-none"
                              style="font-size: 12px"
                              (click)="viewTimelineRemark(item)"
                              title="View Remark"
                            >
                              <i class="fa fa-clipboard me-1"></i>View Remark
                            </a>
                          </li>
                          <!-- <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li>
                                                    <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li>
                                                    <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li>
                                                    <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-7">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <!-- View Remark: remark panel only (Filter hidden until close) -->
                      <div
                        class="col-12 mb-3"
                        *ngIf="timelineRemarkPreview?.remark"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center mb-2"
                        >
                          <h5 class="mb-0">Remark</h5>
                          <button
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            (click)="closeTimelineRemark()"
                          ></button>
                        </div>
                        <div
                          class="p-3 rounded border"
                          style="background-color: #fff3cd"
                        >
                          <label class="form-label fw-semibold mb-1">
                            {{ timelineRemarkPreview?.roleName }}
                            <span *ngIf="timelineRemarkPreview?.auditStatus">
                              — {{ timelineRemarkPreview?.auditStatus }} Remark
                            </span>
                          </label>
                          <div
                            class="text-dark timeline-remark-body"
                            [class.timeline-remark-body--collapsed]="
                              isLongRemarkText(timelineRemarkPreview?.remark) &&
                              !remarkPreviewExpanded
                            "
                            [class.timeline-remark-body--expanded]="
                              isLongRemarkText(timelineRemarkPreview?.remark) &&
                              remarkPreviewExpanded
                            "
                          >
                            {{ timelineRemarkPreview?.remark }}
                          </div>
                          <div
                            class="timeline-remark-actions d-flex justify-content-between align-items-center mt-2"
                          >
                            <a
                              *ngIf="isLongRemarkText(timelineRemarkPreview?.remark)"
                              href="javascript:void(0)"
                              class="timeline-remark-toggle"
                              (click)="toggleRemarkPreviewExpand()"
                            >
                              {{ remarkPreviewExpanded ? 'Show less' : 'Read more' }}
                            </a>
                            <span *ngIf="!isLongRemarkText(timelineRemarkPreview?.remark)"></span>
                            <a
                              *ngIf="timelineRemarkPreview?.FilePath"
                              href="javascript:void(0)"
                              class="btn btn-outline-info btn-sm ms-auto"
                              (click)="
                                downloadFile(timelineRemarkPreview.FilePath)
                              "
                              >Download Document</a
                            >
                          </div>
                        </div>
                      </div>

                      <ng-container *ngIf="!timelineRemarkPreview?.remark">
                        <div class="col-lg-12">
                          <h5>Filter</h5>
                        </div>
                        <form [formGroup]="updateStatusForm">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 mb-3">
                            <label class="form-label"
                              >Select Role<span class="text-danger"
                                >*
                              </span></label
                            >
                            <select
                              class="form-control"
                              formControlName="role"
                              aria-placeholder="Select Role"
                              (change)="changeRole($event)"
                            >
                              <!-- 1968 BI/DI/AR: Select Role = logged-in role only -->
                              <ng-container *ngIf="currentUser?.roleId == 11">
                                <option [value]="11">Block Inspector</option>
                              </ng-container>
                              <ng-container *ngIf="currentUser?.roleId == 12">
                                <option [value]="12">District Inspector</option>
                              </ng-container>
                              <ng-container *ngIf="currentUser?.roleId == 13">
                                <option [value]="13">Assistant Registrar</option>
                              </ng-container>
                              <!-- 2006 DH/BO/Registrar: Select Role = logged-in role only -->
                              <ng-container *ngIf="currentUser?.roleId == 36">
                                <option [value]="36">Dealing Hand</option>
                              </ng-container>
                              <ng-container *ngIf="currentUser?.roleId == 37">
                                <option [value]="37">Branch Officer</option>
                              </ng-container>
                              <ng-container *ngIf="currentUser?.roleId == 38">
                                <option [value]="38">Registrar</option>
                              </ng-container>
                              <ng-container
                                *ngIf="
                                  currentUser?.roleId != 11 &&
                                  currentUser?.roleId != 12 &&
                                  currentUser?.roleId != 13 &&
                                  currentUser?.roleId != 36 &&
                                  currentUser?.roleId != 37 &&
                                  currentUser?.roleId != 38
                                "
                              >
                                <option selected disabled value="">
                                  Select Role
                                </option>
                                <option
                                  *ngFor="let role of roles"
                                  [value]="role?.RoleId"
                                >
                                  {{ role?.RoleName }}
                                </option>
                              </ng-container>
                            </select>
                            <!-- <span> You can only view remarks from other roles; updates are not permitted.</span> -->
                          </div>
                          <div
                            class="col-lg-6 col-md-6 mb-3 d-flex justify-content-center align-items-center"
                          >
                            <div
                              *ngIf="selectedRemarkDetails?.FilePath"
                              class="mt-4"
                            >
                              <a
                                href="javascript:void(0)"
                                class="btn btn-outline-info float-end"
                                (click)="
                                  downloadFile(selectedRemarkDetails.FilePath)
                                "
                                >Download Document
                              </a>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="col-lg-6 col-md-6 mb-3">
                                <label class="form-label">Select Date</label>
                                <select class="form-control">
                                    <option selected disabled>Select Date</option>
                                </select>
                            </div> -->

                        <!-- <div class="col-lg-12">
                                <h5>Status</h5>
                            </div> -->

                        <div
                          class="col-12 row"
                          *ngIf="showStatusUpdatePanel(); else remarkField"
                        >
                          <div class="col-lg-6 col-md-6 mb-3">
                            <label class="form-label"
                              >Select Status<span class="text-danger"
                                >*
                              </span></label
                            >
                            <select
                              class="form-control"
                              formControlName="status"
                              aria-placeholder="Select Status"
                              (change)="onStatusChange()"
                            >
                              <option selected disabled value="">
                                Select Status
                              </option>

                              <option
                                *ngIf="this.currentUser.roleId !== 13"
                                value="1"
                              >
                                Move Forward
                              </option>
                              <option value="7">Send Back</option>
                              <!-- Full approve only (no partial / checkbox selection) -->
                              <option
                                *ngIf="this.currentUser.roleId == 13"
                                value="4"
                              >
                                Approved
                              </option>
                              <!--
                              <option
                                *ngIf="
                                  this.currentUser.roleId == 13 &&
                                  orderData.length == selected.length
                                "
                                value="4"
                              >
                                Approved
                              </option>
                              <option
                                *ngIf="
                                  this.currentUser.roleId == 13 &&
                                  orderData.length > selected.length
                                "
                                value="5"
                              >
                                Partial Approved
                              </option>
                              -->
                              <option
                                *ngIf="this.currentUser.roleId == 13"
                                value="6"
                              >
                                Reject
                              </option>
                            </select>
                          </div>
                          <div
                            class="col-lg-6 col-md-6 mb-3"
                            *ngIf="showStatusFileUpload()"
                          >
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <label
                                for="AmendmentsStatusFile"
                                class="form-label m-0"
                              >
                                <span *ngIf="currentUser?.roleId == 13"
                                  >Upload Certificate<span
                                    *ngIf="showArCertificateUpload()"
                                    class="text-danger"
                                    >*</span
                                  ></span
                                >
                                <span *ngIf="currentUser?.roleId != 13"
                                  >Upload File</span
                                >
                              </label>
                              <a
                                *ngIf="currentUser?.roleId == 13"
                                href="javascript:void(0)"
                                class="fw-semibold text-decoration-none"
                                [class.text-primary]="showArCertificateUpload()"
                                [class.text-muted]="isArCertificateDisabled()"
                                [class.pe-none]="isArCertificateDisabled()"
                                [attr.aria-disabled]="isArCertificateDisabled()"
                                (click)="generateCertificate()"
                              >
                                <i class="fa fa-file-text me-1"></i> Generate
                                Certificate
                              </a>
                            </div>
                            <input
                              class="form-control mt-1 file-upload-input"
                              type="file"
                              id="AmendmentsStatusFile"
                              [disabled]="isArCertificateDisabled()"
                              (change)="onFileSelected($event, 'statusFile')"
                            />
                            <small class="file-upload-hint d-block"
                              >(<span class="text-danger">max size:</span> 2 MB,
                              <span class="text-danger">formats:</span> jpg,
                              jpeg, png, pdf)</small
                            >
                            <!-- 1968 BI / DI / AR: view selected status file -->
                            <a
                              *ngIf="hasStatusFileSelected()"
                              href="javascript:void(0)"
                              class="file-view-link"
                              (click)="viewStatusDocument()"
                            >
                              <i class="fa fa-eye" aria-hidden="true"></i>
                              <span>View</span>
                            </a>
                          </div>
                        </div>

                        <ng-template #remarkField>
                          <div>
                            <div *ngIf="selectedRemarkDetails?.remark">
                              <label class="form-label"
                                >Remarks<span class="text-danger"
                                  >*
                                </span></label
                              >
                              <!-- {{selectedRemarkDetails?.remark}} -->
                              <textarea
                                class="form-control"
                                [value]="selectedRemarkDetails?.remark"
                                disabled="false"
                                placeholder="No Remark Available Now..."
                                rows="4"
                              ></textarea>
                            </div>
                          </div>
                          <!--                                             
                            
                                            <div class="col-lg-12 col-md-6 mb-3" *ngIf="selectedRemarkDetails?.FilePath">
                                                <a href="javascript:void(0)" class=" mt-2 btn btn-outline-info float-end"
                                                    (click)="downloadDocument(selectedRemarkDetails.FilePath)">Download
                                                    Document </a>
                                            </div> -->
                        </ng-template>
                        <div
                          class="col-lg-12"
                          *ngIf="
                            this.currentUser.roleId == 11 &&
                            showStatusUpdatePanel()
                          "
                        >
                          <div formArrayName="checkboxes">
                            <div
                              *ngFor="
                                let option of checkboxOptions;
                                let i = index
                              "
                            >
                              <input
                                type="checkbox"
                                [formControlName]="i"
                                (change)="onBiDisclaimerChange()"
                              />
                              {{ option.label }}
                            </div>
                            <div
                              *ngIf="
                                updateStatusForm.get('checkboxes')?.touched &&
                                updateStatusForm
                                  .get('checkboxes')
                                  ?.hasError('allRequired')
                              "
                            >
                              <p style="color: red">
                                All checkboxes must be selected.
                              </p>
                            </div>
                          </div>
                          <!-- <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="AmendmentsStatusCheckOne">
            <label class="form-check-label" for="AmendmentsStatusCheckOne">
                It is not contrary to the provisions of this Act and the Rules.
            </label>
          </div> -->
                        </div>
                        <div
                          class="col-lg-12"
                          *ngIf="showStatusUpdatePanel()"
                        >
                          <label class="form-label">Add Remarks</label>
                          <textarea
                            class="form-control"
                            formControlName="remark"
                            [placeholder]="
                              updateStatusForm.get('role')?.value ==
                                currentUser?.roleId ||
                              updateStatusForm.get('role')?.value == ''
                                ? 'Please Enter Remark Here...'
                                : 'No Remark Available Now...'
                            "
                            rows="4"
                          ></textarea>
                        </div>

                        <div
                          class="col-lg-12 mt-2 text-end"
                          *ngIf="showUpdateButton()"
                        >
                          <!-- <div class="col-lg-12 text-end" > -->
                          <button
                            type="button"
                            class="btn btn-primary"
                            (click)="updateStatus()"
                          >
                            Update
                          </button>
                        </div>
                        </form>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Read More Model -->
          <div
            class="modal fade animate-fade"
            id="readMoreModal"
            tabindex="-1"
            aria-labelledby="readMoreModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h5
                    class="modal-title election-title"
                    id="readMoreModalLabel"
                  >
                    Full Text
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    (click)="hideViewMore()"
                  ></button>
                </div>
                <div class="modal-body">
                  {{ ExpendeText }}
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                    (click)="hideViewMore()"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal fade disclaimer-modal"
            id="remarkDetails"
            tabindex="-1"
            aria-labelledby="remarkDetailsLabel"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
            >
              <div class="modal-content disclaimer-modal-content">
                <!-- HEADER -->
                <div class="modal-header disclaimer-header">
                  <div class="disclaimer-title-wrapper">
                    <div class="disclaimer-icon">
                      <i class="bi bi-shield-check"></i>
                    </div>

                    <div>
                      <h1 class="modal-title fs-5 mb-0" id="remarkDetailsLabel">
                        Disclaimer Details
                      </h1>

                      <small class="text-muted">
                        View all disclaimer conditions and declarations
                      </small>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn-close custom-close-btn"
                    (click)="closeRemarkModel()"
                  ></button>
                </div>

                <!-- BODY -->
                <div class="modal-body disclaimer-body">
                  <div class="disclaimer-container">
                    <div class="disclaimer-topbar">
                      <div class="disclaimer-count">
                        <i class="bi bi-list-check me-2"></i>
                        Total Disclaimers :
                        <span>{{ disclamerOptions.length || 0 }}</span>
                      </div>
                    </div>

                    <!-- DISCLAIMER LIST -->
                    <div id="disclaimerList">
                      <ng-container>
                        <div
                          class="disclaimer-item"
                          *ngFor="let option of disclamerOptions; let i = index"
                        >
                          <div class="custom-disclaimer-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              [checked]="option.iDisclaimerId"
                              [disabled]="true"
                            />
                          </div>

                          <div class="disclaimer-content">
                            <div class="disclaimer-number">
                              Disclaimer {{ i + 1 }}
                            </div>

                            <label class="form-check-label">
                              {{ option.sDisclaimer }}
                            </label>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 1968 Status Details: view uploaded / generated certificate -->
<div
  class="modal fade"
  id="viewStatusDocumentDetails"
  tabindex="-1"
  aria-labelledby="viewStatusDocumentDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewStatusDocumentDetailsLabel">
          View Document
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="hideModal('viewStatusDocumentDetails')"
        ></button>
      </div>
      <div class="modal-body" *ngIf="base64Pdf">
        <iframe
          [src]="base64Pdf"
          style="width: 100%; height: 75vh; border: none"
          title="Status document preview"
        ></iframe>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="AmendmentsAppDetails2006"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="AmendmentsAppDetails2006Label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
      <!-- HEADER -->
      <div class="modal-header bg-white border-bottom px-4 py-3">
        <div
          class="w-100 d-flex justify-content-between align-items-center flex-wrap gap-3"
        >
          <div>
            <h3 class="fw-bold text-primary mb-1">
              <i class="bi bi-file-earmark-text me-2"></i>
              Amendments Application
            </h3>
          </div>

          <div class="d-flex align-items-center gap-2 flex-wrap">
            <button
              class="btn rounded-pill px-4"
              [ngClass]="
                applicationModel == 1 ? 'btn-primary' : 'btn-outline-primary'
              "
              (click)="toggle(1)"
            >
              <i class="bi bi-card-list me-1"></i>
              Application Details
            </button>

            <button
              class="btn rounded-pill px-4"
              [ngClass]="
                applicationModel == 3
                  ? 'btn-warning text-dark'
                  : 'btn-outline-warning'
              "
              (click)="toggle(3)"
            >
              <i class="bi bi-clock-history me-1"></i>
              Status Details
            </button>

            <button
              type="button"
              class="btn-close ms-2"
              data-bs-dismiss="modal"
              (click)="closeModal()"
            ></button>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12" *ngIf="applicationModel == 1">
            <div>
              <div id="printSection" class="print-container">
                <div
                  class="d-flex justify-content-end align-items-center mb-3 no-print"
                >
                  <button class="btn btn-primary" (click)="print()">
                    <i class="bi bi-printer me-1"></i>
                    Print
                  </button>
                </div>

                <div class="card">
                  <h4 class="election-title text-center">
                    Amendments Application Details
                  </h4>
                  <table>
                    <tr>
                      <td><b>Society ID</b></td>
                      <td>
                        {{ aplicationDetailList?.user?.userLoginId || "-" }}
                      </td>
                      <td><b>Amendment ID</b></td>
                      <td>
                        {{
                          aplicationDetailList?.selectedRow?.iByLawsId || "-"
                        }}
                      </td>
                      <td><b>Amendment Count (Till Date)</b></td>
                      <td>
                        {{ totalAmendmentCount || "-" }}
                      </td>
                      <td><b>Printed On</b></td>
                      <td>{{ printDate | date: "dd/MM/yyyy hh:mm a" }}</td>
                    </tr>
                  </table>
                </div>

                <div class="card mt-3">
                  <div class="election-title">
                    Details of the Authorized Person
                  </div>

                  <table>
                    <tr>
                      <td><b>👤 Name</b></td>
                      <td>
                        {{ aplicationDetailList?.user?.firstName || "-" }}
                      </td>
                    </tr>

                    <tr>
                      <td><b>🏠 Address</b></td>
                      <td>{{ aplicationDetailList?.user?.address || "-" }}</td>
                    </tr>

                    <tr>
                      <td><b>📞 Mobile</b></td>
                      <td>{{ aplicationDetailList?.user?.mobile || "-" }}</td>
                    </tr>

                    <tr>
                      <td><b>✉️ Email</b></td>
                      <td>{{ aplicationDetailList?.user?.email || "-" }}</td>
                    </tr>
                  </table>
                </div>

                <!-- ================= AMENDMENTS ================= -->
                <div class="card mt-3" *ngIf="amendmentsList?.length">
                  <div class="election-title">Amendments Proposed in</div>

                  <table class="custom-table">
                    <tr *ngFor="let item of amendmentsList; let i = index">
                      <td class="index">{{ i + 1 }}.</td>
                      <td class="label">
                        <b>{{ getAmendmentName(item.amendmentType) }}</b>
                      </td>
                      <td class="value">
                        Resolution No. <b>{{ item.resolutionNo }}</b>
                        <span
                          >(dated
                          <b>{{ item.resolutionDate | date: "dd/MM/yyyy" }}</b
                          >)</span
                        >
                      </td>
                    </tr>
                  </table>
                </div>
                <div *ngFor="let group of groupedBylaws">
                  <!-- TASK: hide Proposed section when empty — undo if manager asks to revert -->
                  <div class="card mt-3" *ngIf="groupHasProposed(group)">
                    <div class="election-title">
                      Amendments in {{ getAmendmentName(group.amendmentType) }}
                    </div>

                    <table>
                      <thead>
                        <tr>
                          <th><b>Existing</b></th>
                          <th><b>Proposed</b></th>
                        </tr>
                      </thead>

                      <tbody>
                        <ng-container *ngFor="let item of group.bylaws">
                          <tr *ngIf="hasProposedContent(item.proposedChange)">
                            <td>
                              <ol
                                class="amendment-lines mb-0"
                                *ngIf="
                                  item.existingDetails?.length;
                                  else noExisting
                                "
                              >
                                <li *ngFor="let line of item.existingDetails">
                                  {{ line }}
                                </li>
                              </ol>
                              <ng-template #noExisting>-</ng-template>
                            </td>
                            <td>
                              <ol class="amendment-lines mb-0">
                                <li *ngFor="let line of item.proposedChange">
                                  {{ line }}
                                </li>
                              </ol>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- ================= GENERAL BODY MEMBERS ================= -->
                <div class="card mt-3" *ngIf="societyMemberList?.length">
                  <div class="election-title">General Body Members</div>

                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <!-- <th>Name</th>
                                                <th>Age</th>
                                                <th>Gender</th>
                                                <th>Father/Husband</th>
                                                <th>Address</th>
                                                <th>Occupation</th>
                                                <th>Type of Member</th>
                                                <th>Fee / Challan</th> -->
                        <th>General Details</th>
                        <th>Age</th>
                        <th>Address</th>
                        <th>Martial Status</th>
                        <th>Occupation</th>
                        <th>Admission Fee</th>
                        <!-- <th>Designation</th> -->
                        <th>Document</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let item of societyMemberList; let i = index">
                        <td>{{ i + 1 }}</td>
                        <!-- <td>{{ item.sMemName }}</td>
                                                <td>{{ item.sMemAge }}</td>
                                                <td>{{ item.sGender }}</td>

                                                <td>
                                                    {{
                                                    item.sGender === 'Male'
                                                    ? item.sFatherName
                                                    : item.sMaritalStatus === 'Married'
                                                    ? item.sMemHusName
                                                    : item.sFatherName
                                                    }}
                                                </td>

                                                <td>{{ item.sAdd1 }} {{ item.sAdd2 }}</td>
                                                <td>{{ item.sOccupation }}</td>
                                                <td>{{ item.sMembershiptypename }}</td>
                                                <td>{{ item.sMemShipFee || 'N/A' }}</td> -->
                        <td>
                          <span>
                            Name : <b> {{ item.sMemName }} </b>({{
                              item.sMembershiptypename
                            }}) </span
                          ><br />
                          <span
                            >Father’s / Husband Name :
                            <b>
                              {{
                                item.sGender === "Male" &&
                                (item.sMaritalStatus === "Married" ||
                                  item.sMaritalStatus === "Unmarried")
                                  ? item.sFatherName
                                  : item.sGender === "Female" &&
                                      item.sMaritalStatus === "Married"
                                    ? item.sMemHusName
                                    : item.sFatherName
                              }}</b
                            > </span
                          ><br />

                          <!-- <span>Age : <b> {{ item.sMemAge + ' years'}} </b> </span><br />
                                                    <span>Gender : <b> {{ item.sGender ? item.sGender:'NA'}} </b>
                                                    </span><br /> -->
                          <!-- <span>Category : <b> {{ item.sMemberCast }} </b> </span><br/> -->

                          <!-- <span>Occupation : <b> {{ item.sOccupation ? item.sOccupation:'NA'}}
                                                        </b> </span><br />

                                                    <span> Marital Status : <b> {{ item?.sMaritalStatus}} </b>
                                                    </span><br />

                                                    <span> Admission Fee : <b> ₹{{ item?.sMemShipFee}} </b>
                                                    </span><br /> -->
                        </td>
                        <td>{{ item.sMemAge }}</td>
                        <td>{{ item.sAdd1 }} {{ item.sAdd2 }}</td>
                        <td>{{ item.sMaritalStatus }}</td>
                        <td>{{ item.sOccupation }}</td>
                        <td>{{ item.sMemShipFee }}</td>
                        <!-- <td>{{ item.sMemberDesignation }}</td> -->

                        <td>
                          <button
                            class="no-print btn btn-success btn-sm"
                            (click)="downloadFile(item.sUploadAadharCardPath)"
                          >
                            <i class="bi bi-download me-1"></i>
                          </button>

                          <span class="print-only">Document Attached</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- ================= GOVERNING BODY ================= -->
                <div class="card mt-3" *ngIf="societyMemberList?.length">
                  <div class="election-title">Governing Body Members</div>

                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Designation</th>
                        <th>Gender</th>
                        <th>Occupation</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        *ngFor="
                          let item of filteredGoverningMembers;
                          let i = index
                        "
                      >
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.sMemName }}</td>
                        <td>{{ item.sMemberDesignation }}</td>
                        <td>{{ item.sGender }}</td>
                        <td>{{ item.sOccupation }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="card mt-3">
                  <div class="election-title">Registration Documents</div>
                  <table>
                    <thead>
                      <tr>
                        <th>Document</th>
                        <th>Attachment</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>Registration Bylaws</td>

                        <td>
                          <button
                            class="no-print btn btn-success btn-sm"
                            (click)="
                              downloadFile(
                                aplicationDetailList?.selectedRow
                                  ?.registrationBylaws
                              )
                            "
                          >
                            <i class="bi bi-download me-1"></i>
                          </button>

                          <span class="print-only">Document Attached</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- ================= DOCUMENTS ================= -->
                <div class="card mt-3">
                  <div class="election-title">Requisite Documents</div>

                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Document</th>
                        <th>Attachment</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let key of Uploadedkeys; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ formatLabel(key) }}</td>

                        <td>
                          <button
                            class="no-print btn btn-success btn-sm"
                            (click)="downloadFile(uploadedFiles[key])"
                          >
                            <i class="bi bi-download me-1"></i>
                          </button>

                          <span class="print-only">Document Attached</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12" *ngIf="applicationModel == 3">
            <div class="row">
              <div class="col-lg-12">
                <h6 class="election-title">Amendments Application Status</h6>
              </div>
              <div class="col-lg-5">
                <div class="card">
                  <div class="card-body">
                    <div class="step-progressbar">
                      <div class="v-progress progress-area">
                        <ul>
                          <li
                            *ngFor="let item of bylawsProgress"
                            [class]="item?.ProgressClass"
                          >
                            {{ item?.AuditStatus }} -
                            <small style="font-size: 12px">{{
                              item?.dCreatedDate | date: "dd/MM/yyyy"
                            }}</small>
                            <br />
                            <b style="font-size: 12px"
                              >( {{ item?.RoleName }} )</b
                            >
                            <a
                              *ngIf="canShowOfficerViewRemark(item)"
                              href="javascript:void(0)"
                              class="ms-2 text-primary fw-semibold text-decoration-none"
                              style="font-size: 12px"
                              (click)="viewTimelineRemark(item)"
                              title="View Remark"
                            >
                              <i class="fa fa-clipboard me-1"></i>View Remark
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-7">
                <div class="card">
                  <div class="card-body">
                    <!-- <div class="row" *ngIf="amendmentType !== 4">
                      
                    </div> -->
                    <div class="row" >
                      <!-- 2006: View Remark panel (hides Filter until close) -->
                      <div
                        class="col-12 mb-3"
                        *ngIf="timelineRemarkPreview?.remark"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center mb-2"
                        >
                          <h5 class="mb-0">Remark</h5>
                          <button
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            (click)="closeTimelineRemark()"
                          ></button>
                        </div>
                        <div
                          class="p-3 rounded border"
                          style="background-color: #fff3cd"
                        >
                          <label class="form-label fw-semibold mb-1">
                            {{ timelineRemarkPreview?.roleName }}
                            <span *ngIf="timelineRemarkPreview?.auditStatus">
                              — {{ timelineRemarkPreview?.auditStatus }} Remark
                            </span>
                          </label>
                          <div
                            class="text-dark timeline-remark-body"
                            [class.text-muted]="
                              timelineRemarkPreview?.remark === 'not remark added'
                            "
                            [class.timeline-remark-body--collapsed]="
                              isLongRemarkText(timelineRemarkPreview?.remark) &&
                              !remarkPreviewExpanded
                            "
                            [class.timeline-remark-body--expanded]="
                              isLongRemarkText(timelineRemarkPreview?.remark) &&
                              remarkPreviewExpanded
                            "
                          >
                            {{ timelineRemarkPreview?.remark }}
                          </div>
                          <div
                            class="timeline-remark-actions d-flex justify-content-between align-items-center mt-2"
                          >
                            <a
                              *ngIf="isLongRemarkText(timelineRemarkPreview?.remark)"
                              href="javascript:void(0)"
                              class="timeline-remark-toggle"
                              (click)="toggleRemarkPreviewExpand()"
                            >
                              {{ remarkPreviewExpanded ? 'Show less' : 'Read more' }}
                            </a>
                            <span *ngIf="!isLongRemarkText(timelineRemarkPreview?.remark)"></span>
                            <a
                              *ngIf="timelineRemarkPreview?.FilePath"
                              href="javascript:void(0)"
                              class="btn btn-outline-info btn-sm ms-auto"
                              (click)="
                                downloadFile(timelineRemarkPreview.FilePath)
                              "
                            >
                              Download Document
                            </a>
                          </div>
                        </div>
                      </div>

                      <ng-container >
                      <div class="col-lg-12">
                        <h5 class="election-title">Filter</h5>
                      </div>
                      <form [formGroup]="updateStatusForm">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 mb-3">
                            <label class="form-label"
                              >Select Role<span class="text-danger"
                                >*
                              </span></label
                            >
                            <select
                              class="form-control"
                              formControlName="role"
                              aria-placeholder="Select Role"
                              (change)="changeRole($event)"
                            >
                              <!-- 2006 Status Details: only logged-in DH / BO / Registrar -->
                              <ng-container *ngIf="currentUser?.roleId == 36">
                                <option [value]="36">Dealing Hand</option>
                              </ng-container>
                              <ng-container *ngIf="currentUser?.roleId == 37">
                                <option [value]="37">Branch Officer</option>
                              </ng-container>
                              <ng-container *ngIf="currentUser?.roleId == 38">
                                <option [value]="38">Registrar</option>
                              </ng-container>
                              <ng-container
                                *ngIf="
                                  currentUser?.roleId != 36 &&
                                  currentUser?.roleId != 37 &&
                                  currentUser?.roleId != 38
                                "
                              >
                                <option selected disabled value="">
                                  Select Role
                                </option>
                                <option
                                  *ngFor="let role of roles"
                                  [value]="role?.RoleId"
                                >
                                  {{ role?.RoleName }}
                                </option>
                              </ng-container>
                            </select>
                          </div>
                          <div
                            class="col-lg-6 col-md-6 mb-3 d-flex justify-content-center align-items-center"
                          >
                            <div
                              *ngIf="selectedRemarkDetails?.FilePath"
                              class="mt-4"
                            >
                              <a
                                href="javascript:void(0)"
                                class="btn btn-outline-info float-end"
                                (click)="
                                  downloadFile(selectedRemarkDetails.FilePath)
                                "
                                >Download Document
                              </a>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="col-lg-6 col-md-6 mb-3">
                                <label class="form-label">Select Date</label>
                                <select class="form-control">
                                    <option selected disabled>Select Date</option>
                                </select>
                            </div> -->

                        <!-- <div class="col-lg-12">
                                <h5>Status</h5>
                            </div> -->

                        <div
                          class="col-12 row"
                          *ngIf="showStatusUpdatePanel(); else remarkField"
                        >
                          <div class="col-lg-6 col-md-6 mb-3">
                            <label class="form-label"
                              >Select Status<span class="text-danger"
                                >*
                              </span></label
                            >
                            <select
                              class="form-control"
                              formControlName="status"
                              aria-placeholder="Select Status"
                            >
                              <option selected disabled value="">
                                Select Status
                              </option>

                              <option
  *ngIf="
    currentUser.roleId !== 13 &&
    currentUser.roleId !== 38 &&
    !(+amendmentType === 4 && sNOCUpload == null)
  "
  value="1"
>
  Move Forward
</option>

                              <option
                                *ngIf="
                                  (this.currentUser.roleId == 13) ||
                                  this.currentUser.roleId == 38 && !(+amendmentType === 4 && sNOCUpload == null)
                                "
                                value="4"
                              >
                                Approved
                              </option>
                              <!-- Partial Approved removed — full approve / reject / send back only
                              <option
                                *ngIf="
                                  this.currentUser.roleId == 13 &&
                                  orderData.length > selected.length
                                "
                                value="5"
                              >
                                Partial Approved
                              </option>
                              -->
                              <option
                                *ngIf="
                                  this.currentUser.roleId == 13 ||
                                  this.currentUser.roleId == 38 && amendmentType != 4
                                "
                                value="6"
                              >
                                Reject
                              </option>

                              <option value="9" *ngIf="currentUser?.roleId == 38 && sNOCUpload === null">Issue NOC</option>
                              <option value="10" *ngIf="currentUser?.roleId == 36 && sNOCUpload === null">Request For NOC</option>
                              <option value="7">Send Back</option>
                            </select>
                          </div>
                          <div class="col-lg-6 col-md-6 mb-3">
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <label
                                for="AmendmentsStatusFile"
                                class="form-label m-0"
                              >
                                <span *ngIf="currentUser?.roleId == 13"
                                  >Upload Certificate<span class="text-danger"
                                    >*</span
                                  ></span
                                >
                                <span *ngIf="currentUser?.roleId != 13"
                                  >Upload File</span
                                >
                              </label>
                              <a
                                *ngIf="currentUser?.roleId == 13"
                                href="javascript:void(0)"
                                class="text-primary fw-semibold text-decoration-none"
                                (click)="generateCertificate()"
                              >
                                <i class="fa fa-file-text me-1"></i> Generate
                                Certificate
                              </a>
                            </div>
                            <input
                              class="form-control mt-1 file-upload-input"
                              type="file"
                              id="AmendmentsStatusFile"
                              (change)="onFileSelected($event, 'statusFile')"
                            />
                            <small class="file-upload-hint d-block"
                              >(<span class="text-danger">max size:</span> 2 MB,
                              <span class="text-danger">formats:</span> jpg,
                              jpeg, png, pdf)</small
                            >
                            <a
                              *ngIf="hasStatusFileSelected()"
                              href="javascript:void(0)"
                              class="file-view-link"
                              (click)="viewStatusDocument()"
                            >
                              <i class="fa fa-eye" aria-hidden="true"></i>
                              <span>View</span>
                            </a>
                          </div>
                        </div>

                        <ng-template #remarkField>
                          <div>
                            <div *ngIf="selectedRemarkDetails?.remark">
                              <label class="form-label"
                                >Remarks<span class="text-danger"
                                  >*
                                </span></label
                              >
                              <!-- {{selectedRemarkDetails?.remark}} -->
                              <textarea
                                class="form-control"
                                [value]="selectedRemarkDetails?.remark"
                                disabled="false"
                                placeholder="No Remark Available Now..."
                                rows="4"
                              ></textarea>
                            </div>
                          </div>
                          <!--                                             
                            
                                            <div class="col-lg-12 col-md-6 mb-3" *ngIf="selectedRemarkDetails?.FilePath">
                                                <a href="javascript:void(0)" class=" mt-2 btn btn-outline-info float-end"
                                                    (click)="downloadDocument(selectedRemarkDetails.FilePath)">Download
                                                    Document </a>
                                            </div> -->
                        </ng-template>
                        <!-- BI disclaimer checkboxes only in AmendmentsAppDetails (1968).
                             Removed duplicate formArrayName that broke BI Update validation. -->
                        <div
                          class="col-lg-12"
                          *ngIf="showStatusUpdatePanel()"
                        >
                          <label class="form-label">Add Remarks</label>
                          <textarea
                            class="form-control"
                            formControlName="remark"
                            [placeholder]="
                              updateStatusForm.get('role')?.value ==
                                currentUser?.roleId ||
                              updateStatusForm.get('role')?.value == ''
                                ? 'Please Enter Remark Here...'
                                : 'No Remark Available Now...'
                            "
                            rows="4"
                          ></textarea>
                        </div>

                        <div
                          class="col-lg-12 mt-2 text-end"
                          *ngIf="showUpdateButton()"
                        >
                          <button
                            type="button"
                            class="btn btn-primary"
                            (click)="updateStatus()"
                          >
                            Update
                          </button>
                        </div>
                      </form>
                      </ng-container>
                    </div>
                    <!-- <div class="row" *ngIf="amendmentType === 10">
                      <form [formGroup]="nocStatusForm" class="w-100">
                        <div class="col-lg-12 mb-3">
                          <label class="form-label">
                            Remarks <span class="text-danger">*</span>
                          </label>

                          <textarea
                            class="form-control"
                            formControlName="nocRemark"
                            placeholder="Enter remarks..."
                            rows="4"
                          ></textarea>

                          <div
                            class="text-danger mt-1"
                            *ngIf="
                              nocStatusForm.get('nocRemark')?.touched &&
                              nocStatusForm.get('nocRemark')?.invalid
                            "
                          >
                            Remarks is required.
                          </div>
                        </div>

                        <div class="col-lg-6 col-md-6 mb-3" *ngIf="[36, 38].includes(currentUser?.roleId)">
                          <label class="form-label">
                            Select Status <span class="text-danger">*</span>
                          </label>
                          <select class="form-control" formControlName="status">
                            <option disabled value="">Select Status</option>
                            <option *ngIf="currentUser.roleId === 36" value="1">Move Forward</option>
                            <option *ngIf="currentUser.roleId === 38" value="4">Issue NOC</option>
                            <option value="7">Send Back</option>
                          </select>
                        </div>

                        <div class="col-lg-6 col-md-6 mb-3" *ngIf="currentUser?.roleId === 38">
                          <label for="NocStatusFile" class="form-label">Upload Documents</label>
                          <input
                            class="form-control"
                            type="file"
                            id="NocStatusFile"
                            (change)="onFileSelected($event, 'statusFile', nocStatusForm)"
                          />
                          <sup
                            >(<span class="text-danger">max size:</span> 2 MB,
                            <span class="text-danger">formats:</span> jpg,
                            jpeg, png, pdf)</sup
                          >
                        </div>

                        <div class="col-lg-12 text-end">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            [disabled]="nocStatusForm.get('nocRemark')?.invalid || ([36, 38].includes(currentUser?.roleId) && nocStatusForm.get('status')?.invalid)"
                            (click)="updateStatus()"
                          >
                            Request For NOC
                          </button>
                        </div>
                      </form>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Read More Model -->
          <div
            class="modal fade animate-fade"
            id="readMoreModal"
            tabindex="-1"
            aria-labelledby="readMoreModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h5
                    class="modal-title election-title"
                    id="readMoreModalLabel"
                  >
                    Full Text
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    (click)="hideViewMore()"
                  ></button>
                </div>
                <div class="modal-body">
                  {{ ExpendeText }}
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                    (click)="hideViewMore()"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal fade"
            id="remarkDetails"
            tabindex="-1"
            aria-labelledby="remarkDetailsLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="remarkDetailsLabel">
                    Disclaimer Details
                  </h1>
                  <button
                    type="button"
                    class="btn-close"
                    (click)="closeRemarkModel()"
                  ></button>
                </div>

                <div class="modal-body">
                  <div class="card-body">
                    <div class="step-progressbar">
                      <div>
                        <div id="disclaimerList">
                          <ng-container>
                            <div
                              class="col-md-12"
                              *ngFor="
                                let option of disclamerOptions;
                                let i = index
                              "
                            >
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  [checked]="option.iDisclaimerId"
                                  [disabled]="true"
                                />
                                <label class="form-check-label">{{
                                  option.sDisclaimer
                                }}</label>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-lg-12 col-md-6 mb-3" *ngIf="selectedRemarkDetails?.FilePath">
                          <label class="form-label"></label>
                          <a href="javascript:void(0)" class=" mt-5 btn btn-secondary"
                              (click)="downloadDocument(selectedRemarkDetails.FilePath)">Download
                              Document </a>
                      </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="paymentModal" tabindex="-1">
  <div
    class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
  >
    <div class="modal-content border-0 shadow rounded-4 overflow-hidden">
      <!-- Header -->
      <div
        class="modal-header text-white border-0"
        style="background: linear-gradient(180deg, #0b2d4f, #184c86)"
      >
        <h5 class="modal-title fw-bold">
          <i class="fa fa-money-check-alt me-2"></i>
          Payment Verification Details
        </h5>

        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-4" style="background: #f4f8fc">
        <div class="table-responsive">
          <table class="table table-bordered align-middle bg-white shadow-sm">
            <tbody>
              <tr>
                <th width="35%" style="background: #e8f0fb">
                  Application Ref No
                </th>
                <td>{{ selectedPayment?.AppRefNo }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Department Ref No</th>
                <td>{{ selectedPayment?.DeptRefNo }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Module Type</th>
                <td>{{ selectedPayment?.ModuleType }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Reference ID</th>
                <td>{{ selectedPayment?.ReferenceId }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Fee Type</th>
                <td>{{ selectedPayment?.FeeType }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Fee Amount</th>
                <td class="fw-bold text-success">
                  ₹ {{ selectedPayment?.FeeAmount }}
                </td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Head Of Account</th>
                <td>{{ selectedPayment?.HeadOfAccount }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Bank Name</th>
                <td>{{ selectedPayment?.BankName }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Bank CIN</th>
                <td>{{ selectedPayment?.BankCIN }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Challan No</th>
                <td>{{ selectedPayment?.ChallanNo }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Challan Date</th>
                <td>
                  {{
                    selectedPayment?.ChallanDate | date: "dd-MM-yyyy hh:mm a"
                  }}
                </td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Transaction ID</th>
                <td>{{ selectedPayment?.EchTxnId }}</td>
              </tr>

              <tr>
                <th style="background: #e8f0fb">Payment Status</th>
                <td>
                  <span
                    class="badge px-3 py-2 text-white"
                    style="background: #198754"
                    *ngIf="selectedPayment?.IsPaid"
                  >
                    Paid
                  </span>

                  <span
                    class="badge px-3 py-2 text-white"
                    style="background: #dc3545"
                    *ngIf="!selectedPayment?.IsPaid"
                  >
                    Unpaid
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer border-0 bg-white">
        <button
          type="button"
          class="btn text-white px-4 py-2 fw-semibold rounded-3 border-0"
          style="
            background: linear-gradient(180deg, #0b2d4f, #184c86);
            min-width: 170px;
          "
          *ngIf="showVerifyButton"
          (click)="verifyPayment()"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-check-circle me-2"></i>
          Verify Payment
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="InspectApplication"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="InspectApplicationLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title election-title" id="InspectApplicationLabel">
          Certificate Details
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          #objCloseButton
        ></button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3" *ngFor="let cert of certificateList">
              <div
                class="card shadow-sm h-100 certificate-card"
                (click)="selectCertificate(cert)"
              >
                <div
                  class="card-body d-flex justify-content-between align-items-center"
                >
                  <!-- LEFT CONTENT -->
                  <div>
                    <h6 class="mb-1 fw-bold">
                      {{ cert.label }}
                    </h6>

                    <small class="text-muted">
                      Registration No: {{ cert.regNo }}
                    </small>
                  </div>

                  <!-- RIGHT ICON -->
                  <div>
                    <i class="bi bi-arrow-right-circle fs-4 text-primary"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form>
            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th style="width: 70px">S.No.</th>
                  <th>Society Name</th>

                  <th
                    *ngIf="
                      currentUser.roleId == 36 &&
                      !societyDetails?.certificatePath
                    "
                  >
                    Actions
                  </th>

                  <th *ngIf="societyDetails?.certificatePath">Certificate</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>1</td>
                  <td>{{ societyDetails?.sSocietyName }}</td>

                  <td
                    *ngIf="
                      currentUser.roleId === 36 &&
                      !societyDetails?.certificatePath
                    "
                  >
                    <!-- <a href="javascript:void(0)" class="text-success fw-semibold me-3"
                              (click)="openCertificate(societyDetails)">
                              <i class="bi bi-file-earmark-text me-1"></i> Generate
                            </a> -->
                    <!-- <a *ngIf="aadhaarBase64" href="javascript:void(0)" class="text-primary fw-semibold me-3"
                              (click)="previewFile(aadhaarBase64,'IdentityDetails')">
                              <i class="bi bi-eye me-1"></i> View
                            </a> -->

                    <!-- File Select -->
                    <input
                      type="file"
                      class="form-control form-control-sm mt-2"
                      accept=".pdf,image/*"
                      (change)="onFileSelect($event)"
                    />

                    <!-- Upload Button -->
                    <button
                      type="button"
                      class="btn btn-primary btn-sm mt-2"
                      [disabled]="!selectedCertificateFile"
                      (click)="uploadCertificate()"
                    >
                      Upload
                    </button>
                  </td>

                  <td *ngIf="societyDetails?.certificatePath">
                    <div class="d-flex align-items-center gap-2">
                      <span class="badge bg-success d-flex align-items-center">
                        <i class="bi bi-check-circle-fill me-2"></i>
                        Issued Certificate
                      </span>

                      <button
                        type="button"
                        class="btn btn-outline-success btn-sm d-flex align-items-center"
                        (click)="downloadFile(societyDetails?.certificatePath)"
                      >
                        <i class="bi bi-download me-1"></i>
                        Download
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>

          <!-- ================= PREVIEW MODAL ================= -->
        </div>
      </div>
    </div>
  </div>
</div>
<!--Information-->

<div
  class="modal fade"
  id="certificateDetails"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="certificateDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content p-3">
      <div class="modal-header election-title">
        <h5>Select Certificate</h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3" *ngFor="let cert of certificateList">
          <div
            class="card shadow-sm h-100 certificate-card"
            (click)="selectCertificate(cert)"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center"
            >
              <!-- LEFT CONTENT -->
              <div>
                <h6 class="mb-1 fw-bold">
                  {{ cert.label }}
                </h6>

                <small class="text-muted">
                  Registration No: {{ cert.regNo }}
                </small>
              </div>

              <!-- RIGHT ICON -->
              <div>
                <i class="bi bi-arrow-right-circle fs-4 text-primary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button> -->
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="openCertificateDetails"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="certificateDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div
          class="modal-header d-flex justify-content-between align-items-center"
        >
          <h5 class="modal-title election-title mb-0">
            <!-- {{ selectedCertificate?.label }} -->
          </h5>

          <div class="d-flex align-items-center gap-2">
            <!-- <a target="_blank" (click)="printCertificate('certificates')" class="btn btn-primary btn-sm">
                                <i class="fa fa-print"></i>
                            </a> -->

            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-bs-dismiss="modal"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>

        <div class="modal-body">
          <!-- ✅ PASS TYPE + DATA -->
          <app-certificate
            id="certificates"
            [type]="selectedCertificate?.type"
            [data]="selectedCertificate"
          >
          </app-certificate>
        </div>
      </div>
    </div>
  </div>
</div>

<!---------------------13.1 Assistant Registrar - Amendments - Review Application - Application Details End---------------------------->
<!---------------------13.2 Assistant Registrar - Amendments - Review Application - Process Order End---------------------------->
<!---------------------13.3 Assistant Registrar - Amendments - Review Application - Status Details End---------------------------->
